import { LocaleContext } from '../../contexts/language';
import React from 'react';

const useTranslatedField = () => {
  return (obj, field)=> {
    const { lang } = React.useContext(LocaleContext);
    return obj?.[field]?.[lang] || obj?.[field]?.en || '';
  };
};


export const useTranslation=()=>{
  return (obj)=>{
    const { lang } = React.useContext(LocaleContext);
    return obj?.[lang] || obj?.en;
  };
};
export default useTranslatedField;